import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Button } from '@components/Button';
import { BackgroundCloudImage } from '@components/BackgroundCloudImage';

export const InfoWrapper = styled(Flex)`
  height: 100vh;
  min-height: 864px;
  padding: 0;
  overflow: hidden;
  position: relative;
  ${themeMediaQuery('sm')} {
    height: 37vh;
    min-height: 500px;
  }
  ${themeMediaQuery('md')} {
    height: 68vh;
    min-height: 430px;
  }
  ${themeMediaQuery('lg')} {
    height: 50vh;
    min-height: 430px;
  }
  ${themeMediaQuery('xl')} {
    height: 80vh;
    min-height: 400px;
  }
`;

export const InfoColumnLeft = styled(Flex)`
  width: 50%;
  position: relative;
  z-index: 1;
  > img {
    transform: scale(1.5);
    position: relative;
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
  ${themeMediaQuery('sm')} {
    > img {
      transform: scale(1.4);
      position: relative;
    }
  }
  ${themeMediaQuery('md')} {
    > img {
      transform: scale(1.5);
    }
  }
`;

export const InfoColumnRight = styled(BackgroundCloudImage)`
  display: flex;
  width: 50%;
  justify-content: center;
  padding-left: 82px;
  z-index: 2;
  background-color: white;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    padding: 190px 30px;
    background-size: cover;
  }
`;

export const StyledBox = styled(Flex)`
  margin: auto;
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  ${themeMediaQuery('below_sm')} {
    padding: 20px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
  }
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 332px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
    .text-pairing-eyebrow {
      text-align: center;
      width: 100%;
    }
    .text-pairing-body {
      text-align: center;
    }
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-body {
      max-width: 367px;
      font-size: 17px;
      line-height: 27px;
    }
  }
`;

export const StyledButtonBox = styled(Box)`
  width: 100%;
  text-align: left;
  ${themeMediaQuery('below_sm')} {
    text-align: center;
  }
`;

export const StyledButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 15px;
    height: 45px;
    line-height: 43px;
  }
`;
